import { useState, useEffect, useRef } from "react";
import styles from "./custom-date-input.module.scss";
import { formatDateToDDMMYYYY, formatDateToYYYYMMDD, validRealDate } from "./date-utils";

const CustomDateInput = ({
	id,
	name,
	label,
	value,
	onChange,
	setValue,
	index = null,
	placeholder = "",
	required = false,
	disabled = false,
	error = "",
	helper = "",
	size = "md",
	col = 12,
	autoFocus = false,
	className,
	style,
}) => {
	const [inputType, setInputType] = useState("text");
	const [dateValue, setDateValue] = useState(value || "");
	const [isValid, setIsValid] = useState(true);

	const stableIdRef = useRef(id || `${name || "date-input"}-${Math.random().toString(36).slice(2)}`);
	const inputId = stableIdRef.current;

	let colClass;
	if (col === 3) {
		colClass = styles.col3;
	} else if (col === 6) {
		colClass = styles.col6;
	} else {
		colClass = styles.col12;
	}

	let describedBy;
	if (error || !isValid) {
		describedBy = `${inputId}-error`;
	} else if (helper) {
		describedBy = `${inputId}-helper`;
	} else {
		describedBy = undefined;
	}

	useEffect(() => {
		const dateWithoutTime = value ? value.split(" ")[0] : "";
		setDateValue(dateWithoutTime);
	}, [value]);

	const handleFocus = () => {
		setInputType("date");
	};

	const handleBlur = () => {
		setInputType("text");
		const valid = dateValue ? validRealDate(dateValue) : true;
		setIsValid(valid);
		if (valid) {
			if (setValue) {
				setValue(index, dateValue);
			} else if (onChange) {
				onChange(dateValue);
			}
		}
	};

	const handleChange = (e) => {
		const newValue = e.target.value;
		setDateValue(newValue);
		const valid = newValue ? validRealDate(newValue) : true;
		setIsValid(valid);

		if (inputType === "text" && newValue) {
			const reformattedDate = formatDateToYYYYMMDD(newValue);
			if (setValue) {
				setValue(index, reformattedDate);
			} else if (onChange) {
				onChange(reformattedDate);
			}
		} else if (!newValue) {
			if (setValue) {
				setValue(index, "");
			} else if (onChange) {
				onChange("");
			}
		}
	};

	const displayValue = inputType === "date" ? dateValue : formatDateToDDMMYYYY(dateValue);
	const hasError = error || !isValid;

	return (
		<div className={`${styles.field} ${colClass} ${className || ""}`} style={style}>
			{label ? (
				<label htmlFor={inputId} className={styles.label}>
					{label} {required ? <span className={styles.req}>*</span> : null}
				</label>
			) : null}

			<div className={styles.inputWrapper}>
				<input
					id={inputId}
					name={name}
					type={inputType}
					className={`${styles.input} ${styles[size]} ${hasError ? styles.inputError : ""}`}
					value={displayValue}
					onChange={handleChange}
					onFocus={handleFocus}
					onBlur={handleBlur}
					placeholder={placeholder}
					required={required}
					disabled={disabled}
					autoFocus={autoFocus}
					aria-invalid={hasError || undefined}
					aria-describedby={describedBy}
				/>
			</div>

			{hasError && (
				<div id={`${inputId}-error`} className={styles.error}>
					{error || "Fecha inválida"}
				</div>
			)}

			{!hasError && helper && (
				<div id={`${inputId}-helper`} className={styles.helper}>
					{helper}
				</div>
			)}
		</div>
	);
};

export default CustomDateInput;
